<template>
  <div>
    <div class="add_box">
      <div><span>增加列:</span></div>
      <div>
        宽度：
        <el-input-number v-model="colsSize" :step="3" size="mini" :min="0" :max="12" label="描述文字"></el-input-number>
        <el-button size="mini" style="margin-left: 5px" type="primary" @click="addCols">增加</el-button>
      </div>
    </div>
    <div class="add_box">
      <div><span>增加行:</span></div>
      <div>
        高度：
        <el-input-number
          v-model="rowsSize"
          :step="5"
          size="mini"
          :min="1"
          :max="100"
          label="描述文字"
        ></el-input-number>
        <el-button size="mini" style="margin-left: 5px" type="primary" @click="addRows">增加</el-button>
      </div>
    </div>
    <div>
      <button @click="saveCode">保存布局组件代码</button>
    </div>
    <!-- <div class="add_box">
      <div>
        <el-button size="mini" type="primary" @click="del">删除</el-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import { v1 } from "uuid"
const uuid = { v1 }
export default {
  data() {
    return {
      colsLen: null,
      rowsLen: null,
      colsSize: 0,
      rowsSize: 1,
      baseCol: {
        uid: null,
        alignSelf: "stretch", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
        md: 3, //单个宽度 不用cols，统一用md
        offsetMd: 0, //偏移量
        height: "100%"
      },
      rows: {
        height: "20%",
        margin: {
          //Top: "2%",//可配置margin
        },
        alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
        cols: [
          {
            uid: null,
            alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
            height: "100%",
            md: 12, //单个宽度 不用cols，统一用md
            offsetMd: 0 //偏移量
          }
        ]
      },
      cols: {
        uid: null,
        alignSelf: "stretch",
        md: 4,
        height: "100%",
        offsetMd: 0,
        component: null,
        rows: [
          {
            height: "100%",
            margin: { Top: "0%" }, //可配置margin,首字母大写
            alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
            cols: [
              {
                uid: null,
                alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                height: "100%",
                md: 12, //单个宽度 不用cols，统一用md
                offsetMd: 0 //偏移量
              }
            ]
          }
        ]
      },
      colsInCols: {
        //这个要放在rows里push
        height: "100%",
        alginH: "center",
        cols: [
          {
            uid: "c84d3r56",
            alignSelf: "stretch",
            md: 12,
            height: "100%",
            offsetMd: 0,
            rows: [
              {
                height: "100%",
                margin: {
                  Top: "0%" //可配置margin
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  {
                    uid: "qr2dcs51ced5d1a65dw",
                    alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0 //偏移量
                  }
                ]
              }
            ]
          }
        ]
      },
      colsInColsAgian: {
        uid: "c84d3r56",
        alignSelf: "stretch",
        md: 12,
        height: "100%",
        offsetMd: 0,
        rows: [
          {
            height: "100%",
            margin: {
              Top: "0%" //可配置margin
            },
            alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
            cols: [
              {
                uid: "qr2dcs51ced5d1a65dw",
                alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                height: "100%",
                md: 12, //单个宽度 不用cols，统一用md
                offsetMd: 0 //偏移量
              }
            ]
          }
        ]
      }
    }
  },
  props: {
    container_id: {
      type: Number,
      default: null
    },
    rect_id: {
      type: Number,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  watch: {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  created() {},
  methods: {
    saveCode() {
      let filecontent =
        this.$store.state[this.request_prefix].page.children[this.ids.container_id].children[this.ids.rect_id].options
      console.log(filecontent)
      //定义文件内容，类型必须为Blob 否则createObjectURL会报错
      let content = new Blob([JSON.stringify(filecontent)])
      //生成url对象
      let urlObject = window.URL || window.webkitURL || window
      let url = urlObject.createObjectURL(content)
      //生成<a></a>DOM元素
      let el = document.createElement("a")
      //链接赋值
      el.href = url
      el.download = "code.txt"
      //必须点击否则不会下载
      el.click()
      //移除链接释放资源
      urlObject.revokeObjectURL(url)
    },
    addTable() {
      const colsLen = this.colsLen
      const rowsLen = this.rowsLen
      const rowHeight = (100 / rowsLen).toFixed(2)
      const colsWidth = (12 / colsLen) % 1 === 0 ? 12 / colsLen : this.getSuitableWidth(colsLen)
      new Array(rowsLen).fill(1).forEach(tempRow => {
        const rowId = this.addRows(rowHeight)
        new Array(colsLen).fill(1).forEach((tempCol, index) => {
          this.addCols(rowId, colsWidth, index)
        })
      })
    },
    addRows(fixedSize) {
      const shouldIn = this.handleSizeCheck("addRows") || fixedSize
      if (shouldIn) {
        let newRows = JSON.parse(JSON.stringify(this.rows))
        newRows.height = typeof fixedSize === "number" ? fixedSize + "%" : this.rowsSize + "%"
        newRows.cols[0].uid = uuid.v1()
        const param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.ids.uid,
          type: "addRows",
          appendData: newRows
        }
        if (this.ids.uid === null) {
          param.baseCol = this.baseCol
        }
        this.$store.dispatch(this.request_prefix + "/addLayoutBlock", param)
        return newRows.cols[0].uid
      }
    },
    addCols(fixedId, colsWidth, index) {
      console.log(fixedId, typeof fixedId)
      const shouldIn = this.handleSizeCheck("addCols") || fixedId
      if (shouldIn) {
        const _colsSize = colsWidth ? (Array.isArray(colsWidth) ? colsWidth[index] : colsWidth) : this.colsSize
        const newCols = JSON.parse(JSON.stringify(this.cols))
        const colsInCols = JSON.parse(JSON.stringify(this.colsInCols))
        const baseCol = JSON.parse(JSON.stringify(this.baseCol))
        baseCol.uid = uuid.v1()
        baseCol.md = _colsSize
        colsInCols.cols[0].uid = uuid.v1()
        colsInCols.cols[0].rows[0].cols[0].uid = uuid.v1()
        colsInCols.cols[0].rows[0].cols[0].md = _colsSize
        newCols.md = _colsSize
        newCols.uid = uuid.v1()
        newCols.rows[0].cols[0].uid = uuid.v1()
        const param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: typeof fixedId !== "object" ? fixedId : this.ids.uid,
          type: "addCols",
          appendData: newCols,
          colsInCols,
          baseCol
        }
        this.$store.dispatch(this.request_prefix + "/addLayoutBlock", param)
      }
    },
    handleSizeCheck(type) {
      if (type === "addCols") {
        if (this.colsSize === 0) {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "宽度不能为0！！",
            type: "error"
          })
          return false
        }
        return true
      }
      if (type === "addRows") {
        return true
      }
    },

    del() {}
  }
}
</script>

<style lang="scss" scoped>
.add_box {
  width: 100%;
  padding: 5px 5%;
  margin-bottom: 5px;
  border: 1px solid skyblue;
  div {
    margin-top: 5px;
  }
}
.slider {
  padding: 0 10px;
}
</style>
